module.exports = __webpack_public_path__ + "img/img12.b2c24046.jpg";